import { buildNestedRows } from "./nested/buildNestedRows";
import { NestedEditorRow } from "./nested/nestedRowTypes";
import { DraftAccount, DraftGroup } from "./draftState";

const collectAccounts = (
    rows: NestedEditorRow[],
    collectedAccounts: DraftAccount[],
): void => {
    for (const row of rows) {
        if (row.kind === "account" && row.account) {
            collectedAccounts.push(row.account);
        }
        if (row.children) {
            collectAccounts(row.children, collectedAccounts);
        }
    }
};

interface OrderAccountsCanonicallyParams {
    accounts: DraftAccount[];
    groups: DraftGroup[];
}

// Canonical account order: the nested tree's depth-first traversal with
// group/section/tier rows dropped (leaf-section order, then sortOrder within
// each scope, with custom-group members as a contiguous block).
export const orderAccountsCanonically = ({
    accounts,
    groups,
}: OrderAccountsCanonicallyParams): DraftAccount[] => {
    const orderedAccounts: DraftAccount[] = [];
    collectAccounts(buildNestedRows({ accounts, groups }), orderedAccounts);
    return orderedAccounts;
};
